import "./input-chip.scss";

import { typedMemo } from "src/types";
import {
  InputChipOption,
  InputChipProps,
} from "src/types/widgets/input-chip.types";
import { concatClasses, formatLabel } from "src/utils";

export const InputChip = typedMemo(
  ({
    name,
    label,
    disabled,
    validationSchema,
    value: selectedOptionId,
    options,
    handleBlur,
    handleChange,
    classes,
    classesOption,
    classesLabel = "input-chip--label",
  }: InputChipProps) => {
    const allClassesOption = (id: string) =>
      concatClasses(
        `input-chip--option${id === selectedOptionId ? "-selected" : ""}`,
        ` ${classesOption}`,
        disabled ? "cursor-not-allowed color-disabled" : "cursor-pointer"
      );

    const allClassesOptions = concatClasses("chip-container", classes);

    const Label = (
      <label htmlFor={name} className={classesLabel}>
        {formatLabel(validationSchema, name, label)}
      </label>
    );

    const Option = ({ id, value }: InputChipOption, index: number) => (
      <label key={index} className={allClassesOption(id)}>
        <input
          type="button"
          value={id}
          disabled={disabled}
          name={name}
          onBlur={handleBlur}
          onClick={handleChange}
          hidden
        />
        {value}
      </label>
    );

    const Options = (
      <div className={allClassesOptions}>{options?.map(Option)}</div>
    );

    return (
      <main id={`input-${name}`}>
        {label && Label}
        {Options}
      </main>
    );
  }
);
